import {texture} from "../../core/AssetHelpers";
import {Particles} from "../../core/Particles";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {AnimationContext} from "./AnimationContext";

export class ParticlesAngNotes extends Particles {

    constructor(item: SceneItem, context: AnimationContext, cb: Callback) {
        super([
            texture("ang_shower_note1")!,
            texture("ang_shower_note2")!,
        ], {
            alpha: {
                start: 1,
                end: 1,
            },
            scale: {
                start: 2,
                end: 1.5,
                minimumScaleMultiplier: 0.5,
            },
            color: {
                start: "#ffffff",
                end: "#ffffff",
            },
            speed: {
                start: 200,
                end: 400,
                minimumSpeedMultiplier: 0.5,
            },
            acceleration: {
                x: 0,
                y: 0,
            },
            maxSpeed: 0,
            startRotation: {
                min: -100,
                max: -80,
            },
            noRotation: true,
            rotationSpeed: {
                min: 0,
                max: 0,
            },
            lifetime: {
                min: 1,
                max: 2,
            },
            blendMode: "normal",
            frequency: 0.1,
            emitterLifetime: -1,
            maxParticles: 100,
            pos: {
                x: 0,
                y: 0,
            },
            addAtBack: false,
            spawnType: "rect",
            spawnRect: {
                x: 0,
                y: 0,
                w: item.width / item.scale.x,
                h: item.height / item.scale.y,
            },
        });
        this.emitter.emit = true;
        this.emitter.autoUpdate = true;
        item.addChild(this);
        cb();
    }
}
